import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import logoBlack from './assets/hazdex-orange-black.png';

export default function LoginPage() {
  const { login, loading, authError, clearError } = useContext(AuthContext);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Preload image
  useEffect(() => {
    const img = new Image();
    img.src = logoBlack;
    img.onload = () => setImageLoaded(true);
  }, []);

  // Clear errors when component unmounts
  useEffect(() => {
    return () => {
      if (clearError) {
        clearError();
      }
    };
  }, []);

  if (!imageLoaded) {
    return (
      <div className="min-h-screen bg-[#353535] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#353535] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        {/* Logo and Header */}
        <div className="flex justify-center mb-6">
          <img 
            src={logoBlack}
            alt="HAZDEX" 
            style={{ height: '180px', width: 'auto' }}
          />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-2 text-center">Welcome to HAZDEX</h1>
        <p className="text-[#ff7b01] font-semibold mb-2 text-center">Faster Reports. Smarter Responses.</p>
        <p className="text-gray-600 mb-8 text-center text-sm">Your AI-enhanced after-action reporting and analysis tool</p>

        {/* ✅ ERROR DISPLAY */}
        {authError && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-red-600 mt-0.5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <div>
                <h3 className="text-sm font-medium text-red-800">Authentication Error</h3>
                <p className="text-sm text-red-700 mt-1">{authError}</p>
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <div className="text-center py-8">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#00b7ff]"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
          </div>
        ) : (
          <>
            <button
              onClick={login}
              disabled={loading}
              className="w-full bg-[#ff7b01] text-white py-3 rounded-lg hover:bg-[#f47805] transition font-medium shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sign In
            </button>

            <p className="text-center text-gray-600 text-sm mt-6">
              Don't have an account?{' '}
              <a href="/register" className="text-[#ff7b01] hover:text-[#f47805] font-medium">
                Request Access
              </a>
            </p>
          </>
        )}

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-xs text-gray-500">
            Powered by <span className="font-semibold text-gray-700">Amazon Web Services</span>
          </p>
        </div>
      </div>
    </div>
  );
}